export interface Author {
    email: string;
    firstName?: string;
    lastName?: string;
    userName: string;
    displayName: string;
    jobRole?: string;
    profilePictureUrl?: string;
    id: number;
    profileEnabled: boolean;
    displayNameSet: boolean;
    profileEmail?: string;
    profilePhoneNumber?: string;
    department?: string;
    profilePicture?: string;
    isActive: boolean;
}

export interface Link {
    href: string;
    rel: string;
    method: string;
}

export interface Comment {
    row: number;
    id: number;
    url?: string;
    contentId: number;
    body: string;
    author: Author;
    createDate: Date;
    modifiedDate?: string;
    atMentionUsers: any[];
    links: Link[];
    userLiked: boolean;
    totalLikes: number;
    totalReplies: number;
    status: string;
    deleted: boolean;
    parentId?: string;
    isAppend?: boolean
}

export interface Social {
    totalLikes: number;
    totalComments: number;
    totalReplies: number;
    userLiked: boolean;
    userCommented: boolean;
    comments: Comment[];
    hasNext: boolean;
}

export interface Comments {
    comments: Comment[];
    contentId: string;
    nextUrl: string;
    previousUrl: string 
}


export const defaultContent:Social = {
    totalLikes: 0,
    totalComments: 0,
    totalReplies: 0,
    userLiked: false,
    userCommented: false,
    comments: [],
    hasNext: false
}

export interface DeepLink {
    commentId: number,
    commentDate: string,
    replyId: number,
    replyDate: string
}

export enum sortByComment {
    oldest ="Oldest",
    newest = "Newest"
}
export enum sortByReply {
    oldest = "dateCreatedOldest",
    newest = "dateCreatedNewest"
}

export enum  InteractionSource {
	Unknown = "Unknown",
    Content = "Content",
    ActivityFeed = "ActivityFeed",
    SocialList = "SocialList"
}

export enum InteractionType {
	Unknown = "Unknown",
    ContentCommentButtonClicked = "ContentCommentButtonClicked"
}

export interface IInteractionData {
    appGuid: string,
    contentId: number,
    sourceListId?: number
}